import { Lock } from "lucide-react";

export function VePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-8rem)] px-4 py-20">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-6">
          <Lock className="w-10 h-10 text-primary" />
        </div>
        <h1 className="font-display text-4xl font-black mb-4">
          <span className="gradient-text">Vote-Escrow</span>
        </h1>
        <p className="text-text-secondary text-base mb-6 leading-relaxed">
          Lock DJNN to earn boosted rewards and participate in governance.
          veTokenomics model launching with protocol maturity.
        </p>
        <div className="grid grid-cols-2 gap-4 mb-8 text-left">
          {[
            { label: "Lock DJNN", desc: "Convert DJNN to veDJNN for multiplied rewards" },
            { label: "Governance", desc: "Vote on protocol parameters and fee distribution" },
            { label: "Boosted APR", desc: "Up to 2.5x reward multiplier on liquidity positions" },
            { label: "Fee Share", desc: "Earn 50% of protocol fees proportional to veDJNN" },
          ].map((item) => (
            <div key={item.label} className="p-3 bg-surface/40 border border-border rounded-button">
              <div className="text-sm font-semibold text-text-primary mb-1">{item.label}</div>
              <div className="text-xs text-text-tertiary">{item.desc}</div>
            </div>
          ))}
        </div>
        <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium">
          <Lock className="w-4 h-4" />
          Coming Soon
        </div>
      </div>
    </div>
  );
}
